import { project } from './project'

export const designProject = project
  .required()
  .meta({ label: 'Name your design and select a location', placeholder: 'Name your design...' })
